import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserInfo, UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class AuthorizedGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    const user: UserInfo | null = this.userService.getUserInfo();
    if (user) {
      return true; // User info, allow access to page (all main layout pages, currently, since it is assigned to the main layout)
    }
    return this.router.createUrlTree(['/logout']); // No user info available, they haven't been signed in, redirect back to login page
  }
}
